import { Link } from 'gatsby'
import { Card } from 'maeng-daisyui'
import classNames from 'classnames'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

interface PostListProps {
  posts: {
    id: string
    title: string
    thumbnail?: IGatsbyImageData
    excerpt: string
    slug: string
  }[]
}

const PostList = ({ posts }: PostListProps) => {
  return (
    <div className="max-w-[900px] grid grid-cols-3 gap-x-6 gap-y-8 mx-auto">
      {posts.map(({ id, title, thumbnail, excerpt, slug }) => (
        <Link
          key={id}
          className={classNames(
            'observed observed-hidden relative',
            "hover:before:content-[''] hover:before:absolute hover:before:top-0 hover:before:left-0 hover:before:w-full hover:before:h-full hover:before:bg-gray-500 hover:before:rounded-2xl hover:before:z-10 hover:before:opacity-20",
          )}
          to={slug}
        >
          <Card
            className={classNames(
              '[&>.card-body]:max-h-[200px] [&>.card-body]:min-h-[200px] [&>.card-body]:overflow-hidden',
              '[&>.card-body>.card-content]:overflow-hidden',
            )}
            image={
              thumbnail ? (
                <GatsbyImage
                  className="object-cover w-full h-[150px] bg-slate-100"
                  image={thumbnail}
                  alt={title || slug}
                />
              ) : (
                <div className="object-cover w-full h-[150px] bg-slate-100 bg-[url('../assets/images/face-with-monocle.png')] bg-no-repeat bg-center bg-[length:100px_100px]" />
              )
            }
            title={title || slug}
            content={excerpt}
          />
        </Link>
      ))}
    </div>
  )
}

export default PostList
